module.exports = __webpack_public_path__ + "static/logo_white-ba9b3f44f47d02b55ff21b095d188eaa.png";